(function () {
  "use strict";

  angular.module("sempraWebapp").filter("stringToBoolean", stringToBoolean);

  /** @ngInject */
  function stringToBoolean() {
    return function (input) {
      switch (input) {
        case "vacuums%20not%20installed":
          return false;
        default:
          return true;
      }
    };
  }
})();
